import React, { useEffect, useState } from 'react';
import 'react-day-picker/dist/style.css';
import styled from 'styled-components';
import { useWindowWidth } from "@react-hook/window-size";
import iconDown from "./iconDown.svg"
import iconUp from "./iconUp.svg"
export default function CardAuxSeguimiento(
    {
        data,
        convertirFecha,
        setEditarSeguimiento,
        setIdSeguimiendoAEditar
    }) {
        console.log(data)
    const [verDetalle, setVerDetalle] = useState(false);
    const [verAnotacion, setVerAnotacion] = useState(false);
    const onlyWidth = useWindowWidth();
    const [desplegar, setDesplegar] = useState(false);
    const  [colorCotizacion, setColorCotizacion] = useState("#FFFFFF");
    const  [colorStatus, setColorStatus] = useState("#FFFFFF");
    useEffect(() => {
        if(data.estadoCotizacion === "Cotización no enviada"){
            setColorCotizacion("#6f120f66")
        }
        if(data.estadoCotizacion === "Cotización enviada"){
            setColorCotizacion("#9ad095")
        }
  
    
      }, [data.estadoCotizacion]);
    useEffect(() => {
        if(data.estadoDePoliza === "Solicita otra cotización"){
            setColorStatus("#f5c54b54")
        }
        if(data.estadoDePoliza === "Sin respuesta"){
            setColorStatus("#6f120f66")
        }
        if(data.estadoDePoliza === "Esperando cotización"){
            setColorStatus("#00629585")
        }
        if(data.estadoDePoliza === "No le interesa"){
            setColorStatus("#6f120f66")
        }
        if(data.estadoDePoliza === "Alta de poliza"){
            setColorStatus("#35a12c80")
        }
    
      }, [data.estadoDePoliza]);

      const editsarSeguimiento = () => {
        setIdSeguimiendoAEditar(data)
        setEditarSeguimiento(true)
      }
    return (
        <DivCardContainer desplegar={desplegar}>
            <ItemAux>
                {convertirFecha(data.updatedAt)}
         
                {
                    desplegar === true &&   onlyWidth < 800 ? 
                    <CalendarIconImg onClick={()=> setDesplegar(!desplegar)} src={iconUp}/>
                    :null
                }
                    {
                    desplegar === false &&   onlyWidth < 800 ? 
                    <CalendarIconImg onClick={()=> setDesplegar(!desplegar)}  src={iconDown}/>
                    :null
                }

            </ItemAux>
            <ItemAux 
            style={{
                borderRadius:"8px",
                border:"solid 2px #003049",
                justifyContent:"center",
                padding: "3px"
            }}
            onClick={() =>setVerDetalle(!verDetalle) }>
                {
                    !verDetalle ? 
                    "Ver detalle"
                    :
                   " Cerrar detalle"
                }
       
            </ItemAux>
            {
                verDetalle && onlyWidth < 800 ?
                    <DivContentDetalle>
                      <b>•</b> {data.detalle}
                    </DivContentDetalle>
                    : null
            }
            <ItemAux style={{
                      color: "#000000",
                backgroundColor:colorCotizacion,
                padding: "3px",
                borderRadius:"8px",
                justifyContent:"center"
            }}>
            {data.estadoCotizacion}
            </ItemAux>
            <ItemAux
            
            style={{
                color: "#000000",
                backgroundColor:colorStatus,
                padding: "3px",
                borderRadius:"8px",
                justifyContent:"center"
            }}
            >
            {data.estadoDePoliza}
            </ItemAux>
      
            <ItemAux
            
            style={{
                borderRadius:"8px",
                border:"solid 2px #003049",
                justifyContent:"center",
                padding: "3px"
            }}
            onClick={() =>setVerAnotacion(!verAnotacion) }>
                {
                    !verAnotacion ? 
                    "Ver anotación"
                    :
                   " Cerrar anotación"
                }
       
            </ItemAux>
            {
                verAnotacion && onlyWidth < 800 ?
                    <DivContentDetalle>
                      <b>•</b>{data.anotaciones}
                    </DivContentDetalle>
                    : null
            }
            <ItemAux style={{
                color:'black',
                borderRadius:"8px",
                border:"solid 2px #003049",
                justifyContent:"center",
                padding: "3px",
                cursor:"pointer"
            }}
            onClick={editsarSeguimiento}
            >
                <b>♦Editar♦</b>
            </ItemAux>

            {
                verDetalle && onlyWidth > 800 ?
                    <DivContentDetalle
                style={{
                    marginTop:"16px"
                }}
                >
                           Detalle:<br/>{data.detalle}
                    </DivContentDetalle>
                    : null
            }
              {
                verAnotacion && onlyWidth > 800 ?
                    <DivContentDetalle
                    style={{
                        marginTop:"16px"
                    }}>
                        Anotación:<br/>{data.anotaciones}
                    </DivContentDetalle>
                    : null
            }
            

        </DivCardContainer>
    );
}
const DivContentDetalle = styled.div`
 width: 100%;
 display:flex;
 flex-direction: row;

color: #003049;
font-family: 'Montserrat', sans-serif;
font-weight: 700;
font-size: 13px;
  padding: 8px 0px;
`;
const CalendarIconImg = styled.img`
  max-width:20px;
  max-height:20px;
  width:20px;
  height:20px;
  
`;
const BotonCalendar = styled.div`
border-radius: 100%;
    border-color: #dadce0;
    box-shadow: rgba(0, 0, 0, .1) 0 1px 1px;
    cursor: pointer;
    height: 30px;
    margin: 0px 0px 0px 0px;
    align-self: end;
    align-content: center;
    width: 25px;
    gap: 8px;
    font-family: 'Montserrat',sans-serif;
    font-weight: 500;
    font-size: 12px;
    color: #07082c;
    padding: 4px 8px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  
  &:focus {
    // border-color: #380418;
    outline: none;
  }
  &:hover {
    transition: all 0.1s linear;
    filter: opacity(0.5);
    // transform:scale(0.90)
    box-shadow: rgba(0, 0, 0, .2) 0 1px 1px;
  }
  &:active {
    // transition: all 0.1s linear;
    // filter: opacity(0.9);
    transform:scale(0.90)
  }
`;
const DivCardContainer = styled.div`
width: 100%;
height: auto;
display: flex;
flex-wrap: wrap;
padding: 8px;
box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgb(209, 213, 219) 0px 0px 0px 1px inset;
box-sizing: border-box;
align-items: center;
border-radius:8px;
justify-content: space-between;
gap: 8px;
@media only screen and (min-width: 0px) and (max-width: 800px) {

    width: 100%;
    gap:8px;
    height:  ${(prop) => prop.desplegar === true ? "auto" : "35px"};
    overflow: hidden;
}
`
const ItemAux = styled.div`
flex-grow: 1;
color: #003049;
font-family: 'Montserrat', sans-serif;
font-weight: 600;
font-size: 13px;
display: flex;
flex-direction: row;
justify-content: space-between;
align-items: center;
max-width:   180px;
@media only screen and (min-width: 0px) and (max-width: 800px) {
    width: 100%;
    max-width:   100%;
    font-size: 14px;
}
`
// Componente de selección de hora y minutos

